import { defineMessages } from 'react-intl';

const apnDeprecationUXMessages = defineMessages({
  alertContent: {
    id: 'apnDeprecationUXMessages.alertContent',
    defaultMessage:
      'The APN sign in method will be removed soon. Choose a new sign in method for your account. This will not impact your training data. ',
    decription: 'alert content for APN deprecation',
  },
});

export default apnDeprecationUXMessages;
